import { config } from '@/config';

const LK_LIST = {
    list: [
        {
            href: '/lk/profile',
            icon: 'user',
            link: 'settings',
            name: 'Профиль',
        },
        {
            href: '/lk/visits',
            icon: 'voucher',
            link: 'visits',
            name: 'Мои записи',
        },
        {
            href: '/lk/favorites',
            icon: 'favorite',
            link: 'favorites',
            name: 'Избранное',
        },
        {
            href: '/lk/reviews',
            icon: 'review-reply',
            link: 'reviews',
            name: 'Отзывы и оценки',
        },
    ],
};

const BUSINESS_LIST = {
    list: [
        {
            href: config.BASE_URL,
            icon: 'logo-dark--short',
            link: config.BASE_URL,
            name: 'Tetradka для бизнеса',
            attrs: {
                target: '_blank',
            },
        },
    ],
};

const LK_MENU_LINKS = { ...LK_LIST };

export { LK_MENU_LINKS, LK_LIST, BUSINESS_LIST };
export default { LK_MENU_LINKS, LK_LIST, BUSINESS_LIST };
